import React, { useEffect, useState } from 'react';
import { asve } from '../shared/orve';
import { Container, Row } from 'react-bootstrap';
import { getTip, shuffleArray } from '../shared/report-util';
import { useAuth } from '../../../providers/auth-provider';
import { isStaffingCandidate } from '../../../api/dashboards-api';
import { REPORT_TYPE } from '../../../utils/constants';

const recommendationBreakpoints = {
  breaks: [],
};

function CandidateDevelopmentReportRecommendations({ candidate, reportType = REPORT_TYPE.coaching }) {
  const { clientDisplayName } = useAuth();
  const [candidateTips, setCandidateTips] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const contractPeriod = 'four'; //JO: This will require detail from client profile to make dynamic.

  useEffect(() => {
    if (!initialized) {
      if (reportType === REPORT_TYPE.coaching) {
        const tips = [
          {
            score: candidate.personality?.scores.conscientiousness.overall,
            text: shuffleArray(candidate, asve(candidate).personalityConscientiousnessTips)[0],
          },
          {
            score: candidate.personality?.scores.extraversion.overall,
            text: shuffleArray(candidate, asve(candidate).personalityExtraversionTips)[0],
          },
          {
            score: candidate.personality?.scores.honestyHumility.overall,
            text: shuffleArray(candidate, asve(candidate).personalityHonestyHumilityTips)[0],
          },
          {
            score: candidate.personality?.scores.emotionalControl.overall,
            text: shuffleArray(candidate, asve(candidate).personalityEmotionalControlTips)[0],
          },
        ];

        setCandidateTips(tips);
      } else {
        const tips = [
          {
            score: candidate.personality?.scores.conscientiousness.overall,
            text: shuffleArray(candidate, asve(candidate).staffingPersonalityConscientiousnessTips)[0],
          },
          {
            score: candidate.personality?.scores.honestyHumility.overall,
            text: shuffleArray(candidate, asve(candidate).staffingPersonalityHonestyHumilityTips)[0],
          },
          {
            score: candidate.personality?.scores.emotionalControl.overall,
            text: shuffleArray(candidate, asve(candidate).staffingPersonalityEmotionalControlTips)[0],
          },
          {
            score: candidate.personality?.scores.agreeableness.overall,
            text: shuffleArray(candidate, asve(candidate).staffingPersonalityAgreeablenessTips)[0],
          },
        ];

        setCandidateTips(tips);
      }
      setInitialized(true);
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {initialized && (
        <>
          <Row className="justify-content-center w-25 mx-auto pt-3">
            <hr style={{ borderTop: '2px solid' }} />
          </Row>
          {!isStaffingCandidate(candidate) ? (
            <>
              <Row className="w-100 mx-auto pb-2">
                Although another candidate was offered the role you recently applied for at {clientDisplayName}, the
                organization wanted to make this experience as positive as possible and provide you with two important
                elements. First, a list of development tips or recommendations based on the assessments that you
                completed as part of the job process. The recommendations included in this report are targeted tips that
                can be applied to your current role and/or any leadership role in your future.
              </Row>
              <Row className="w-100 mx-auto pb-4">
                Second, {clientDisplayName} has contracted with Hutrics to provide you with our digital coaching
                offering at no charge to you. The digital coaching will provide you with a series of emails for the next{' '}
                {contractPeriod} months that will focus on your developmental areas with specific recommendations and
                case studies to help you in your journey. We also encourage you to check job listings at{' '}
                {clientDisplayName} for future openings that you may be a better fit.
              </Row>
            </>
          ) : (
            <Row className="w-100 mx-auto pb-4">
              Although another candidate was offered the role that you recently applied for at {clientDisplayName}, the
              organization wanted to make this experience as positive as possible by providing you with a list of
              developmental tips/recommendations based on the assessments that you completed as part of the job
              candidate process. The recommendations included in this report are targeted tips that can be applied to
              your current role or any role in your future.
            </Row>
          )}
          <h3 className="pt-4">Development Recommendations</h3>
          {candidateTips.length > 0 && (
            <Row className="w-100 mx-auto justify-content-center pt-1 pb-4">
              {candidateTips.map((tip) => getTip(tip.score, tip.text, recommendationBreakpoints))}
            </Row>
          )}
        </>
      )}
    </Container>
  );
}

export default CandidateDevelopmentReportRecommendations;
